import React from 'react';

const Services: React.FC = () => {
  const services = [
    {
      id: 1,
      title: 'E-COMMERCE PLATFORMS',
      description: 'Complete online shopping solutions with secure payment gateways, inventory management, and customer analytics.',
      features: ['Shopping Cart', 'Payment Processing', 'Inventory Management', 'Customer Analytics'],
      status: 'COMING SOON',
      borderColor: 'border-bkash-red',
      hoverBgColor: 'hover:bg-bkash-red',
      hoverTextColor: 'group-hover:text-bkash-white',
      textColor: 'text-bkash-red'
    },
    {
      id: 2,
      title: 'ACCOUNTING SOFTWARE',
      description: 'Professional accounting and financial management systems for businesses of all sizes.',
      features: ['General Ledger', 'Accounts Payable/Receivable', 'Financial Reporting', 'Tax Management'],
      status: 'IN DEVELOPMENT',
      borderColor: 'border-bkash-blue',
      hoverBgColor: 'hover:bg-bkash-blue',
      hoverTextColor: 'group-hover:text-bkash-white',
      textColor: 'text-bkash-blue'
    },
    {
      id: 3,
      title: 'RESTAURANT MANAGEMENT',
      description: 'Comprehensive restaurant management system including POS, inventory, and customer relationship management.',
      features: ['Point of Sale', 'Menu Management', 'Staff Scheduling', 'Customer Loyalty'],
      status: 'PLANNING',
      borderColor: 'border-retro-yellow',
      hoverBgColor: 'hover:bg-retro-yellow',
      hoverTextColor: 'group-hover:text-bkash-dark',
      textColor: 'text-retro-yellow'
    },
    {
      id: 4,
      title: 'ENTERPRISE SOLUTIONS',
      description: 'Custom enterprise software solutions tailored to your specific business needs and workflows.',
      features: ['Custom Development', 'API Integration', 'Cloud Deployment', '24/7 Support'],
      status: 'AVAILABLE',
      borderColor: 'border-retro-green',
      hoverBgColor: 'hover:bg-retro-green',
      hoverTextColor: 'group-hover:text-bkash-white',
      textColor: 'text-retro-green'
    }
  ];

  return (
    <section id="services" className="py-16 bg-bkash-bg">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-bkash-dark mb-4 border-b-2 border-bkash-red pb-2">
            OUR PRODUCTS & SERVICES
          </h2>
          <p className="text-lg text-bkash-gray max-w-2xl mx-auto">
            Discover our comprehensive suite of technology solutions designed to transform your business operations
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
          {services.map((service) => (
            <div 
              key={service.id} 
              className={`border-2 ${service.borderColor} bg-bkash-white p-6 ${service.hoverBgColor} transition-all duration-300 group rounded-lg shadow-sm hover:shadow-md`}
            >
              {/* Service Header */}
              <div className="flex justify-between items-start mb-4">
                <h3 className={`text-xl font-bold text-current ${service.hoverTextColor}`}>{service.title}</h3>
                <span className={`text-xs px-2 py-1 border border-current bg-transparent ${service.hoverTextColor} group-hover:border-current rounded`}>
                  {service.status}
                </span>
              </div>

              {/* Description */}
              <p className={`text-sm mb-4 text-current ${service.hoverTextColor}`}>
                {service.description}
              </p>

              {/* Features List */}
              <div className="mb-4">
                <h4 className={`text-sm font-bold mb-2 text-current ${service.hoverTextColor}`}>KEY FEATURES:</h4>
                <ul className="space-y-1">
                  {service.features.map((feature, index) => (
                    <li key={index} className={`text-xs text-current ${service.hoverTextColor} flex items-center`}>
                      <span className="mr-2">▶</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Action Button */}
              <button className={`w-full border border-current px-4 py-2 text-sm font-bold transition-colors ${service.hoverTextColor} group-hover:border-current rounded`}>
                LEARN MORE
              </button>
            </div>
          ))}
        </div>

        {/* Coming Soon Notice */}
        {/* <div className="mt-12 text-center">
          <div className="bg-bkash-white border-2 border-bkash-red p-6 max-w-4xl mx-auto rounded-lg shadow-sm">
            <h3 className="text-xl font-bold text-bkash-red mb-3">
              🚀 COMING SOON: SHOP.TEKNURA.COM
            </h3>
            <p className="text-bkash-dark mb-4">
              Our flagship e-commerce platform is currently in development. 
              Be the first to know when we launch by joining our waiting list.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className="px-4 py-2 border-2 border-bkash-border bg-bkash-white text-bkash-dark placeholder-bkash-light-gray focus:outline-none focus:border-bkash-red rounded"
              />
              <button className="bg-bkash-red text-bkash-white px-6 py-2 font-bold border-2 border-bkash-red hover:bg-transparent hover:text-bkash-red transition-colors rounded">
                JOIN WAITLIST
              </button>
            </div>
          </div>
        </div> */}

      </div>
    </section>
  );
};

export default Services;
